<script lang="ts" setup>
const { t } = useI18n();
const telestrationStore = useTelestrationStore();

const canGoToPrevious = computed(() => telestrationStore.navigation.canGoToPrevious);
const canGoToNext = computed(() => telestrationStore.navigation.canGoToNext);
const onPrevClick = () => telestrationStore.navigation.previous();
const onNextClick = () => telestrationStore.navigation.next();
</script>

<template>
  <TButton
    :tooltip="t('labels.move_to_prev_telestration')"
    :icon="{ name: 'chevron-left', class: 'h-3' }"
    :disabled="!canGoToPrevious"
    class="hover:bg-blue-500 disabled:hover:bg-transparent"
    @click="onPrevClick"
  />
  <TButton
    :tooltip="t('labels.move_to_next_telestration')"
    :icon="{ name: 'chevron-right', class: 'h-3' }"
    :disabled="!canGoToNext"
    class="hover:bg-blue-500 disabled:hover:bg-transparent"
    @click="onNextClick"
  />
</template>
